import {WdiModalAppProps} from "@/components/WdiControls";
import {message, TableColumnsType} from "antd";
import React, {useEffect, useState} from "react";
import {WdiModal} from "@/components/WdiControls/WdiModalForm";
import {WdiTable} from "@/components/WdiControls/WdiTable";
import {FormSa} from "@/services/sales/sa";
import {Enum} from "@/enums/system";
import {FormSp} from "@/services/sales/sp";

type FormSaColumns = {
  formSaId: number;
  formSaNo: string;
  sfaTypeId: number;
  sfaTypeName: string;
}
const ViewSfaResultApp: React.FC<WdiModalAppProps> = (props) => {
  const {data} = props;
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [columns, setColumns] = useState<TableColumnsType<FormSaColumns>>([]);

  const viewSaSfaCollectionDetail = (formSaId: number, sfaTypeId: number, formSaDetailIds: number[]) => {
    FormSa.Buttons.viewSfaCollectionDetails({
      formId: formSaId,
      key: "ViewSfaCollectionDetailsButton",
      items: [
        {name: 'formId', value: String(formSaId)},
        {name: 'sfaTypeId', value: String(sfaTypeId)},
        {name: 'formSaDetailIds', value: formSaDetailIds.join(',')}
      ],
    }).then(responseResult => {
      if (responseResult.data) {
        window.open(responseResult.data);
        props.onClose?.();
      } else {
        message.error(responseResult.message).then();
      }
    })
  };

  const viewSpSfaCollectionDetail = (formSpId: number, sfaTypeId: number) => {
    FormSp.Buttons.viewSfaCollectionDetails({
      formId: formSpId,
      key: "ViewSfaCollectionDetailsButton",
      items: [
        {name: 'formId', value: String(formSpId)},
        {name: 'sfaTypeId', value: String(sfaTypeId)}
      ]
    }).then(responseResult => {
      if (responseResult.data) {
        window.open(responseResult.data);
        props.onClose?.();
      } else {
        message.error(responseResult.message).then();
      }
    })
  };

  useEffect(() => {
    if (data.formTypeId) {
      // 活动根据 sfaType 分组
      // 核销审批 sfaType 分组
      // 核销申请 formSaId+sfaType 分组
      const formId = Number(props.id);
      if (formId) {
        const extractedData = data.dataSource.filter((item: any) => item.toSfa == true).map((item: any) => ({
          sfaTypeId: item.sfaTypeId,
          sfaTypeName: item.sfaTypeName,
        }));
        const uniqueData = extractedData.filter((item: FormSaColumns, index: any, self: FormSaColumns[]) =>
          index === self.findIndex((t: FormSaColumns) => (t.sfaTypeId === item.sfaTypeId && t.sfaTypeName === item.sfaTypeName))
        );
        if (uniqueData.length == 1) {
          if (data.formTypeId == Enum.FormType.ACTIVITY_APPLICATION) {
            viewSaSfaCollectionDetail(formId, uniqueData[0].sfaTypeId, [])
          } else {
            viewSpSfaCollectionDetail(formId, uniqueData[0].sfaTypeId);
          }
        }
        setDataSource(uniqueData);
        setColumns([
          {
            title: 'SFA查看类型',
            dataIndex: 'sfaTypeId',
            ellipsis: true,
            render: (_, record) => (
              <a onClick={() => {
                if (data.formTypeId == Enum.FormType.ACTIVITY_APPLICATION) {
                  viewSaSfaCollectionDetail(formId, record.sfaTypeId, []);
                } else {
                  viewSpSfaCollectionDetail(formId, record.sfaTypeId);
                }
              }}>
                {record.sfaTypeName}
              </a>),
          },
        ]);
      } else {
        const extractedData = data.dataSource.filter((item: any) => item.toSfa == true).map((item: any) => ({
          formSaId: item.formSaId,
          formSaNo: item.formSaNo,
          sfaTypeId: item.sfaTypeId,
          sfaTypeName: item.sfaTypeName,
        }));
        const uniqueData = extractedData.filter((item: FormSaColumns, index: any, self: FormSaColumns[]) =>
            index === self.findIndex((t: FormSaColumns) => (
              t.formSaId === item.formSaId
              && t.formSaNo === item.formSaNo
              && t.sfaTypeId === item.sfaTypeId
              && t.sfaTypeName === item.sfaTypeName
            ))
        );
        if (uniqueData.length == 1) {
          viewSaSfaCollectionDetail(uniqueData[0].formSaId, uniqueData[0].sfaTypeId, data.dataSource.map((item: any) => item.formSaDetailId));
        }
        setDataSource(uniqueData);
        setColumns([
          {
            title: '活动单号',
            dataIndex: 'formSaNo',
            ellipsis: true,
          }, {
            title: 'SFA查看类型',
            dataIndex: 'sfaTypeId',
            ellipsis: true,
            render: (_, record) => (
              <a onClick={() => {
                const formSaDetailIds = data.dataSource
                  .filter((item: any) => item.formSaId == record.formSaId && item.sfaTypeId == record.sfaTypeId)
                  .map((item: any) => item.formSaDetailId);
                viewSaSfaCollectionDetail(record.formSaId, record.sfaTypeId, formSaDetailIds);
              }}>
                {record.sfaTypeName}
              </a>),
          },
        ]);
      }
    }
  }, [data]);

  return (
    <WdiModal
      title={props.title}
      visible={props.visible}
      width={500}
      onCancel={() => {
        props.onClose?.()
      }}
      onOk={() => {
        props.onClose?.()
      }}>
      <WdiTable
        showPageRows={10}
        columns={columns}
        size='small'
        dataSource={dataSource}
        pagination={false}
      />
    </WdiModal>
  )
}
export default ViewSfaResultApp;
